export function selectTab(tabId) {
    return {
        type: 'TAB_SELECTED',
        payload: tabId
    }
}

export function showTabs(...tabsIds) {
    const tabsToShow = {}
    tabsIds.forEach(e => tabsToShow[e] = true);
    return {
        type: 'TAB_SHOWED',
        payload: tabsToShow
    }
}


// WEBPACK FOOTER //
// ./src/common/tab/tabActions.js